import { useAtom } from 'jotai';
import { atomWithReducer } from 'jotai/utils';
export var MakeAPaymentView;
(function (MakeAPaymentView) {
    MakeAPaymentView["MultiPaymentDetails"] = "MultiPaymentDetails";
    MakeAPaymentView["MultiPaymentDetailsEdit"] = "MultiPaymentDetailsEdit";
    MakeAPaymentView["MultiPaymentReview"] = "MultiPaymentReview";
    MakeAPaymentView["MultiPaymentConfirmation"] = "MultiPaymentConfirmation";
    MakeAPaymentView["MultiPaymentError"] = "MultiPaymentError";
})(MakeAPaymentView || (MakeAPaymentView = {}));
const currentViewReducer = (viewAtom, action) => {
    if (action.type === 'updateView') {
        return Object.assign(Object.assign({}, viewAtom), { view: action.view });
    }
    return viewAtom;
};
const currentViewAtom = atomWithReducer({
    view: MakeAPaymentView.MultiPaymentDetails
}, currentViewReducer);
export const useCurrentViewAtom = () => {
    return useAtom(currentViewAtom);
};
export default currentViewAtom;
